import { isFetchError } from '../rtk-query/fetch-error'
import { captureException } from '@sentry/react'
import { MonitoringError } from './monitoring-error'

export function captureError(e: unknown) {
  if (isFetchError(e)) {
    captureException(new MonitoringError(e))
  }
}
